<template>
  <div v-loading="isBusy">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        element-loading-spinner="el-icon-loading"
        label-width="170px"
    >
      <el-form-item label="Content" prop="content">
        <el-input v-model="form.content"
                  type="textarea"
                  ref="body"
                  :autosize="{minRows: 4}"
        ></el-input>
        <placeholders @select="addPlaceholder" :items="placeholders">
          <el-tooltip content="Placeholders" placement="top">
            <span class="color--prpl cursor-pointer"><i class="fas fa-code"></i></span>
          </el-tooltip>
        </placeholders>
      </el-form-item>
      <el-form-item label="Brands" prop="brands">
        <el-select v-model="form.brands" class="w-100" multiple>
          <el-option
            v-for="option in brandList"
            :key="option.value"
            v-bind="option"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tags" prop="tags">
        <el-select
          v-model="form.tags"
          class="w-100"
          multiple
          filterable
        >
          <el-option
            v-for="option in tagList"
            :key="option.value"
            v-bind="option"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <button class="btn btn-purple px-4" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from '../form';
import Placeholders from '../shared/placeholder/list';
import InputMixin from '../../mixins/inputs';

const placeholders = [
  {key: 1, value: '[[contact_first_name]]'},
  {key: 2, value: '[[contact_last_name]]'},
  {key: 3, value: '[[contact_full_name]]'},
  {key: 4, value: '[[contact_phone_number]]'},
  {key: 5, value: '[[outgoing_number_phone_number]]'},
  {key: 6, value: '[[representative_name]]'},
  {key: 7, value: '[[representative_email]]'},
  {key: 8, value: '[[contact_email]]'},
  {key: 9, value: '[[brand_title]]'},
];

export default {
  extends: BaseForm,

  components: {
    Placeholders,
  },

  props: {
    brandList: Array,
    tagList: Array,
  },

  data() {
    const form = {
      content: null,
      brands: null,
      tags: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      placeholders: placeholders,
    }
  },

  computed: {
    //
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      const form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));

      const overrides = {
        brands: _.map(_.get(model, 'brands', []), 'id'),
        tags: _.map(_.get(model, 'tags', []), 'id'),
      };

      this.form = _.defaults(overrides, form);
    },

    /**
     * @param {string} value
     */
    addPlaceholder(value) {
      this.addTextInCursorPosition(
          _.get(this.$refs, 'body.$refs.textarea'),
          _.toString(this.form.content),
          value,
          this.messageSetter
      );
    },

    /**
     * @param {string} value
     */
    messageSetter(value) {
      this.form.content = value;
    },
  },

  mixins: [
    InputMixin,
  ],
}
</script>
